export default function Menu() {
    return (
        <div className="h-screen flex justify-center items-center bg-green-300 ">
            <h1 className="md:text-9xl text-4xl font-black">メニュー</h1>
        </div>
    )
}